// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__figYw","colMin":"styles_colMin__1a5Cs"};